import { MEDIA_GALLERY_IMAGE_PREFIX, MEDIA_GALLERY_URL_FORMAT_MISC, MEDIA_GALLERY_URL_FORMAT_ABSOLUTE, MEDIA_GALLERY_TAG_MAPPING, MEDIA_GALLERY_URL_FORMAT_DO } from "components/MediaGallery/constants";

export const makeFinalURL = (url: string, dealerId: string, dealerURL: string) => {
    const data = {
        image: url.startsWith(MEDIA_GALLERY_IMAGE_PREFIX) ? url.substr(MEDIA_GALLERY_IMAGE_PREFIX.length) : cleanUpUrl(url),
        dealerId,
        baseURL: cleanHttps(dealerURL)
    }

   
    if (url.startsWith(MEDIA_GALLERY_IMAGE_PREFIX)) {
        return buildImageURL(MEDIA_GALLERY_URL_FORMAT_DO, data, MEDIA_GALLERY_TAG_MAPPING)
    }
    return buildImageURL(MEDIA_GALLERY_URL_FORMAT_ABSOLUTE, data, MEDIA_GALLERY_TAG_MAPPING)

}

export const buildImageURL = (imagePath: string, params: { [x: string]: string }, mapping: { [x: string]: string }) => {
    const allTags: string[] = [];
    const allTagEndings = imagePath.split(">");
    for (const allTagBeginings of allTagEndings) {
        const tagContent = allTagBeginings.split("<");
        if (tagContent.length > 1) {
            allTags.push(`<${tagContent[1]}>`)
        }
    }
    let result = imagePath;
    allTags.forEach(t => {
        const tagMapping = mapping[t];
        if (tagMapping) {
            const tagValue = params[tagMapping];
            if (tagValue) {
                result = result.replace(t, tagValue);
            }
        }
    });

    return result;

}

const cleanHttps= (imagePath: string) => {
    if (imagePath.startsWith("https://"))
        imagePath = imagePath.replace("https://","");
    return imagePath;
}

const cleanUpUrl = (imagePath: string) => {
    if (imagePath.startsWith("/")) {
        return imagePath.slice(1);
    }

    return imagePath;
}